import {HelpLinkService} from './services/help-link-service';
import {HelpLinkRI, UserHelpRI, UserType, NavigationLinkRI} from 'common-utils/rest-interfaces';
import { pdsLogger } from './pds-logger';

import {SinglePopoverWidget} from './single-popover-widget';
import {PopperPlacement} from './popper-configuration';

let log = pdsLogger.prependLogger(pdsLogger.requiresLogger('help-menu'), 'pds-help-menu.ts');

export class PdsHelpMenu extends SinglePopoverWidget {
  is = 'pds-help-menu';

  //When the REST call is made an error occurs, we set userHelpLinks = null;
  userHelpLinks: Array<NavigationLinkRI> | null;
  userType: UserType;
  userDistrictUID: string;
  helpLinkService: HelpLinkService;

  properties = {
    userHelpLinks: {
      type: Array,
      value: []
    },
    userType: {
      type: String,
      value: null,
      observer: 'restCallArgumentsUpdated'
    },
    userDistrictUID: {
      type: String,
      value: null,
      observer: 'restCallArgumentsUpdated'
    }
  };

  attached(): void {
    log('attached() called');
    super.attached();
    this.helpLinkService = new HelpLinkService();
    this.restCallArgumentsUpdated();
  }

  restCallArgumentsUpdated(): void {
    log('attempting to make REST call');
    if (this.userDistrictUID != null && this.userType != null) {
      log('kicking off REST call to fetch the help link service');
      this.fetchHelpLinks();
    }
  }

  fetchHelpLinks(): void {
    if (this.helpLinkService == null) {
      return;
    }

    this.helpLinkService.getNavLinks(this.userDistrictUID, this.userType, ['HELP'], this.pds.preferences.host).subscribe(
      (navLinks: Array<NavigationLinkRI>) => {
        log('response returned from REST call.');
        this.userHelpLinks = navLinks;
      },
      (error) => {
        log('no valid response from the REST call.');
        //Only clobber the array if it is the default empty array.
        if (this.userHelpLinks != null && this.userHelpLinks.length === 0) {
          this.userHelpLinks = null; //null means there was an error
        }
      }
    );
  }

  isRequiredDataDefined(): boolean {
    return this.userHelpLinks != null;
  }

  getPopoverTriggerSelector(): string {
    return '.pds-help-menu-trigger';
  }

  getPopoverSelector(): string {
    return '.pds-help-menu-popover';
  }

  log(message?: any, ...optionalParams: any[]): void {
    log.apply(window, arguments);
  }

  getDefaultAlignment(): PopperPlacement {
    return 'bottom-end';
  }
}
